if (typeof boostPFSThemeConfig !== 'undefined') {
    // Override Settings
    var boostPFSFilterConfig = {
        general: {
            limit: boostPFSConfig.custom.products_per_page,
            /* Optional */
            loadProductFirst: true
            // paginationType: boostPFSConfig.custom.pagination_type.indexOf("load_more") != -1 ? "load_more" :
            // 				(boostPFSConfig.custom.pagination_type == 'infinite_scroll' ? 'infinite' : 'default'),
        },
        selector: {
            trackingQuickView: '.quick_shop'
        }
    };
}

(function () {
    BoostPFS.inject(this);

        // Einordnung des Produkts (Label unter dem Titel).
    // WICHTIG: gleiche Regeln wie snippets/vch-product-label.liquid,
    // boost-pfs-instant-search.js und boost-card-labels.js. Änderungen überall nachziehen.
    function vchProductLabel(data) {
        var tags = data.tags || [];
        var type = data.product_type || '';
        var title = data.title || '';
        var hasTag = function (t) { return tags.indexOf(t) !== -1; };

        var isSchiene = hasTag('Vorhangschiene');
        var isStange = hasTag('Vorhangstange');
        var isSystem = isSchiene || isStange;
        var isPlissee = !isSystem && (hasTag('Plissee') || /^(Waben)?plissee/i.test(title));
        var isRollo = !isSystem && !isPlissee && /Rollo/i.test(type);
        var isZubehoer = !isSystem && !isPlissee && !isRollo && (hasTag('Zubehör') || type === 'Vorhang Zubehör');

        var hasWidth = tags.some(function (t) { return t.indexOf('width:') === 0; });
        var hasFertigTag = tags.some(function (t) { return t.indexOf('Fertigvorhang') === 0 || t.indexOf('mit Faltenband') !== -1; });

        var isMass = !isSystem && !isPlissee && !isRollo && !isZubehoer && !hasFertigTag && (
            type === 'Stoff' ||
            tags.some(function (t) { return t.indexOf('Massvorhang') === 0 || /^\d+ - \d+ Wochen$/.test(t); })
        );
        var isFertig = !isSystem && !isPlissee && !isRollo && !isZubehoer && !isMass && (hasFertigTag || hasWidth);

        var typeLabels = { 'Rollo / Plissée': 'Rollo' };
        if (isSchiene) return 'Vorhangschiene nach Mass';
        if (isStange) return 'Vorhangstange nach Mass';
        if (isPlissee) return 'Plissee nach Mass';
        if (isRollo) return 'Rollo';
        if (isZubehoer) return 'Zubehör';
        if (isMass) return 'Vorhang nach Mass';
        if (isFertig) return 'Fertigvorhang';
        return typeLabels[type] || type;
    }

    function vchIsStoffPage() {
        var href = window.location.href;
        return href.indexOf('vorhang-stoffe') > -1 || href.indexOf('guenstige-vorhangstoffe') > -1;
    }

    // "ab" vor dem Preis bei allem, was konfiguriert wird (nicht auf den Stoff-Seiten)
    function vchShowAb(data) {
        if (vchIsStoffPage()) return false;
        var label = vchProductLabel(data);
        return ['Vorhang nach Mass', 'Plissee nach Mass', 'Vorhangschiene nach Mass', 'Vorhangstange nach Mass'].indexOf(label) !== -1;
    }

    // Build Product Grid Item
    ProductGridItem.prototype.compileTemplate = function (data, index, totalProduct) {
        if (!data) data = this.data;
        if (!index) index = this.index;
        if (!totalProduct) totalProduct = this.totalProduct;
        
      
        var not_public = false;
        var custom_products = false;
        var hidden = '';
      
        data.tags.forEach((tag) => {
          if (tag.indexOf("not_public") != -1) {
             not_public = true;
          }
        });

        data.collections.forEach((collection) => {
        
          if (collection.title.indexOf("custom_products") != -1 || collection.title.indexOf("sample_product") != -1 ) {
             custom_products = true;
          }
        });


        if(not_public == true || custom_products == true ){
          hidden = ' hidden';
        }
       

      

      
        // Get Template
        var itemHtml = boostPFSTemplate.productGridItemHtml;

        // Add class
        var itemDesktopWidthClass = 'one-third'+hidden;
        switch (boostPFSConfig.custom.products_per_row) {
            case 1:
                itemDesktopWidthClass = 'one-whole'+hidden;
                break;
            case 2:
                itemDesktopWidthClass = 'one-half'+hidden;
                break;
            case 3:
                itemDesktopWidthClass = 'one-third'+hidden;
                break;
            case 4:
                itemDesktopWidthClass = 'one-fourth'+hidden;
                break;
            case 5:
                itemDesktopWidthClass = 'one-fifth'+hidden;
                break;
            case 6:
                itemDesktopWidthClass = 'one-sixth'+hidden;
                break;
            case 7:
                itemDesktopWidthClass = 'one-seventh'+hidden;
                break;
            case 8:
                itemDesktopWidthClass = 'one-eighth'+hidden;
                break;
        }
      // console.log(data);
        itemHtml = itemHtml.replace(/{{itemDesktopWidthClass}}/g, itemDesktopWidthClass);
        itemHtml = itemHtml.replace(/{{itemMobileWidthClass}}/g, boostPFSConfig.custom.mobile_products_per_row == 1 ? 'small-down--one-whole' : 'small-down--one-half');
        itemHtml = itemHtml.replace(/{{itemQuickShopClass}}/g, boostPFSConfig.custom.enable_quickshop ? 'quick-shop--true quick-shop--closed product-{{itemId}} js-product_section' : '');
        itemHtml = itemHtml.replace(/{{itemStickersClass}}/g, boostPFSConfig.custom.stickers_enabled ? 'has-thumbnail-sticker' : '');
        itemHtml = itemHtml.replace(/{{itemHoverClass}}/g, boostPFSConfig.custom.thumbnail_hover_enabled?.toString());
        itemHtml = itemHtml.replace(/{{itemSwapImageClass}}/g, boostPFSConfig.custom.show_secondary_image && data.images_info.length > 1 ? 'swap--true' : '');
        itemHtml = itemHtml.replace(/{{itemHoverImage}}/g, boostPFSConfig.custom.show_secondary_image && data.images_info.length > 1 ? 'has-secondary-image-swap' : '');
        itemHtml = itemHtml.replace(/{{itemTextAlignClass}}/g, boostPFSConfig.custom.thumbnail_text_alignment);

        // Add stickers
        var itemStickers = buildStickers(data);
        itemHtml = itemHtml.replace(/{{itemStickers}}/g, itemStickers);

      
        // Add images
        var itemImages = buildImages(data);
        itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImages);

        // Add hover elements
        var itemHover = buildHover(data);
        itemHtml = itemHtml.replace(/{{itemHover}}/g, itemHover);

        // Add product info
        itemHtml = itemHtml.replace(/{{itemProductInfo}}/g, boostPFSTemplate.itemProductInfoHtml);
        

        // Add vendor
        var itemVendor = boostPFSConfig.custom.display_vendor ? '<span class="product-thumbnail__vendor">{{itemVendor}}</span>' : '';
        itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendor);

        var collectionHandles = data.collections.map(x => x.handle);
        var isComingSoon = collectionHandles.indexOf('coming-soon') != -1;
        // Add coming soon
        if (isComingSoon) {
            itemHtml = itemHtml.replace(/{{itemComingSoon}}/g, '<span>' + boostPFSConfig.label.coming_soon + '</span>');
            itemHtml = itemHtml.replace(/{{itemPrice}}/g, '');

            // Add price
        } else {
            itemHtml = itemHtml.replace(/{{itemComingSoon}}/g, '');
            itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
        }

        // Add swatch

        var itemSwatch = buildSwatch(data);
        itemHtml = itemHtml.replace(/{{itemSwatch}}/g, itemSwatch);


        // Add Reviews
        if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
            var itemReviews = boostPFSConfig.custom.enable_shopify_collection_badges && boostPFSConfig.custom.enable_shopify_review_comments ? '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>' : '';
            if (boostPFSConfig.custom.thumbnail_hover_enabled) {
                itemHtml = itemHtml.replace(/{{itemReviewsHover}}/g, itemReviews);
                itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
            } else {
                if (itemReviews != '') {
                    itemReviews = '<div class="product-thumbnail__review-stars is-flex is-justify-' + boostPFSConfig.custom.thumbnail_text_alignment + '">' +
                        '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>' +
                        '</div>';
                }


                itemHtml = itemHtml.replace(/{{itemReviewsHover}}/g, '');
                itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviews);
            }
        }

        // Add quick shop button placeholder
        var itemQuickShop = boostPFSConfig.custom.enable_quickshop ? '<div data-boost-pfs-quickshop-id="{{itemId}}" style="display: none"></div>' : '';
        itemHtml = itemHtml.replace(/{{itemQuickShop}}/g, itemQuickShop);

        // Add main attribute (Always put at the end of this function)
        itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
        itemHtml = itemHtml.replace(/{{itemVariantId}}/g, data.variants[0].id);
        var itemTitle = data.title;
        var hTag = (data.tags || []).find(function(t) { return t.indexOf('height:') === 0; });
        var wTag = (data.tags || []).find(function(t) { return t.indexOf('width:') === 0; });
        if (hTag && wTag) { itemTitle += ' ' + hTag.replace('height:', '') + 'x' + wTag.replace('width:', ''); }
        itemHtml = itemHtml.replace(/{{itemTitle}}/g, itemTitle);

        // Label: auf den Stoff-Seiten der Rohtyp ("Stoff"), sonst gemeinsame Regeln
        var itemTypeLabel = vchIsStoffPage() ? data.product_type : vchProductLabel(data);
        itemHtml = itemHtml.replace(/{{itemType}}/g, '<div class="product-type">' + itemTypeLabel + '</div>');

        itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
        itemHtml = itemHtml.replace(/{{itemVendor}}/g, data.vendor);
        itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));
        itemHtml = itemHtml.replace(/{{itemStoff}}/g, vchIsStoffPage() ? '?stoff' : '');

        return itemHtml;
    };

    function buildStickers(data) {
        var html = '';
        var stickers = [];
        if (boostPFSConfig.custom.stickers_enabled) {
            var collections = data.collections.map(x => x.handle);
            var stickerCollections = ['best-seller', 'coming-soon', 'new', 'pre-order', 'staff-pick'];
            for (var i = 0; i < stickerCollections.length; i++) {
                var stickerCollection = stickerCollections[i];
                if (collections.indexOf(stickerCollection) != -1) {
                    var stickerText = boostPFSConfig.label[stickerCollection.replace('-', '_')];
                    var sticker = '<div class="' + stickerCollection + '-sticker thumbnail-sticker sticker-' + i + '"><span class="sticker-text">' + stickerText + '</span></div>';
                    stickers.push(sticker);
                }
            }

            var onSale = data.available && data.price_min < data.compare_at_price_max;
            var soldOut = !data.available;

            if (onSale) {
                var sticker = '<div class="sale-sticker thumbnail-sticker"><span class="sticker-text">' + boostPFSConfig.label.sale + '</span></div>';
                stickers.push(sticker);
            } else if (soldOut) {
                var sticker = '<div class="sale-sticker thumbnail-sticker"><span class="sticker-text">' + boostPFSConfig.label.sold_out + '</span></div>';
                stickers.push(sticker);
            }

            if (stickers.length > 0) {
                html = '<div class="sticker-holder sticker-shape-' + boostPFSConfig.custom.sticker_shape + ' sticker-position-' + boostPFSConfig.custom.sticker_position + '">' +
                    '<div class="sticker-holder__content sticker-holder__content--">' +
                    stickers.join('') +
                    '</div>' +
                    '</div>';
            }
        }
        return html;
    }

    function buildImages(data) {
        var html = '';
        var images = data.images_info;
        if (!images || images.length == 0) {
            images.push({
                src: boostPFSAppConfig.general.no_image_url,
                width: 480,
                height: 480
            })
        }

        html += buildImageElement(images[0]);

        if (boostPFSConfig.custom.show_secondary_image && images.length > 1) {
            html += buildImageElement(images[1], 'lazypreload secondary swap--visible');
        }

        return html;
    }

    function buildImageElement(image, additionalClass) {
        var additionalClass = (typeof additionalClass !== 'undefined') ? additionalClass : '';
        var html = '';
        var heightStyle = '';
        var widthStyle = '';
        var aspectRatio = image.width / image.height;
        if (boostPFSConfig.custom.align_height) {
            heightStyle += 'max-height: ' + boostPFSConfig.custom.collection_height + 'px;';
            // widthStyle += 'width: calc(' + image.width + ' / ' + image.height + ' * ' + boostPFSConfig.custom.collection_height + 'px)';
            // widthStyle += 'width: '+ (aspectRatio * boostPFSConfig.custom.collection_height) +'px; max-width: '+ image.width +'px;';
        }

        var backgroundColor = boostPFSConfig.custom.image_loading_style == 'color' ? 'background: url(' + Utils.optimizeImage(image.src, '1x') + '); ' : '';
        var lowQualityImage = boostPFSConfig.custom.image_loading_style == 'blur-up' ? Utils.optimizeImage(image.src, '50x') : '';

        html += 
          '<div class="image-element__wrap" style="' + backgroundColor + heightStyle + widthStyle + '">' +
            '<img alt="{{itemTitle}}"' +
            ' class="lazyload transition--' + boostPFSConfig.custom.image_loading_style + ' ' + additionalClass + '"' +
            (lowQualityImage && lowQualityImage !== '' ?
                ' src="' + lowQualityImage + '"' : '') +
            ' data-src="' + Utils.optimizeImage(image.src, '1600x') + '"' +
            ' data-sizes="auto"' +
            ' data-aspectratio="' + aspectRatio + '"' +
            ' data-srcset="' + bgset(image) + '"' +
            ' srcset="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="' +
            ' height="' + image.height + '"' +
            ' width="' + image.width + '"' +
            ' style="' + heightStyle + '"' +
            '/>' +
            '</div>';
        return html;
    }

    function buildHover(data) {
        var html = '';
        if (boostPFSConfig.custom.enable_quickshop || boostPFSConfig.custom.thumbnail_hover_enabled) {
            html = boostPFSTemplate.itemHoverHtml;
            if (boostPFSConfig.custom.thumbnail_hover_enabled) {
                var itemProductInfoHover = '<div class="quick-shop__info animated fadeInDown">' +
                    '<div class="thumbnail-overlay">' +
                    '<div class="info text-align-center">' +
                    '{{itemProductInfo}}' +
                    '</div>' +
                    '</div>' +
                    '</div>';
                html = html.replace(/{{itemProductInfoHover}}/g, itemProductInfoHover);
            } else {
                html = html.replace(/{{itemProductInfoHover}}/g, '');
                html = html.replace(/{{itemReviews}}/g, '');
            }
            if (!boostPFSConfig.custom.enable_quickshop) {
                html = html.replace(/{{itemQuickShop}}/g, '');
            }
        }
        return html;
    }

    function buildPrice(data) {
        var html = '';
        var onSale = data.compare_at_price_max > data.price_min;
        var soldOut = !data.available;
        var priceVaries = data.price_max != data.price_min;
        // console.log(data.price_min, onSale, soldOut)
        html += '<span class="product-thumbnail__price price ' + (onSale ? 'sale' : '') + '"> ';
        if (data.price_min > 0) {
            if (priceVaries || vchShowAb(data)) {
                html += '<small><em>' + boostPFSConfig.label.from + '</em></small> ';
            }
            html += '<span class="money">' + Utils.formatMoney(data.price_min, 'money_with_currency') + '</span> ';
        } else {
            html += boostPFSConfig.custom.free_price_text;
        }
        if (onSale) {
            html += '<span class="product-thumbnail__was-price compare-at-price">' +
                '<span class="money">' + Utils.formatMoney(data.compare_at_price_max, 'money_with_currency') + '</span>' +
                '</span>';
        }
        html += '</span>';

        return html;
    }

    function buildSwatch(data) {
        var html = '';
        var values = [];
        var swatchItems = [];
        // if (boostPFSConfig.custom.collection_swatches) {
        //   data.variants.forEach(function (variant) {
        //     var colorValue = '';
        //     var optionValue = '';
        //     variant.merged_options.forEach(function (option) {
        //       var key = option.split(':')[0];
        //       var value = option.split(':')[1];
        //       if ((key.toLowerCase().indexOf('color') != -1 || key.toLowerCase().indexOf('colour') != -1) && values.indexOf(value.toLowerCase()) == -1) {
        //         values.push(value.toLowerCase());
        //         colorValue = value;
        //         optionValue = key;
        //       }
        //     });
        //     if (colorValue) {
        //       var swatchItem = '<a href="{{variantUrl}}" class="swatch swatch__style--{{swatchShape}}" data-swatch-name="meta-{{slugifyOptionValue}}_{{slugifyColorValue}}">' +
        //         '<span data-image="{{variantImage}}" style="background-color: {{colorBackground}}; background-image: url({{variantImage}});">' +
        //         '<img class="swatch__image" src="{{colorImage}}" onerror="this.className += \' swatch__image--empty\'">' +
        //         '</span>' +
        //         '</a>';

        //       swatchItem = swatchItem.replace(/{{swatchShape}}/g, boostPFSConfig.custom.collection_swatches_shape);
        //       swatchItem = swatchItem.replace(/{{colorBackground}}/g, Utils.slugify(colorValue).split('-').pop());
        //       swatchItem = swatchItem.replace(/{{slugifyOptionValue}}/g, Utils.slugify(optionValue).replace('-', '_'));
        //       swatchItem = swatchItem.replace(/{{slugifyColorValue}}/g, Utils.slugify(colorValue).replace('-', '_'));
        //       swatchItem = swatchItem.replace(/{{variantUrl}}/g, Utils.buildProductItemUrl(data) + '?variant=' + variant.id);

        //       var colorImage = boostPFSAppConfig.general.file_url.split('?')[0] + Utils.slugify(colorValue) + '_50x.png';
        //       swatchItem = swatchItem.replace(/{{colorImage}}/g, colorImage);

        //       var variantImage = '';
        //       var noImageClass = '';
        //       if (variant.image) {
        //         switch (boostPFSConfig.custom.products_per_row) {
        //           case 2: variantImage = Utils.optimizeImage(variant.image, '600x'); break;
        //           case 3: variantImage = Utils.optimizeImage(variant.image, '500x'); break;
        //           default: variantImage = Utils.optimizeImage(variant.image, '400x'); break;
        //         }
        //       }
        //       swatchItem = swatchItem.replace(/{{variantImage}}/g, variantImage);
        //       swatchItems.push(swatchItem);
        //     }
        //   })
        // }
        // if (swatchItems.length > 0) {
        //   html = '<div class="thumbnail-swatch is-justify-' + boostPFSConfig.custom.thumbnail_text_alignment + ' is-flex-wrap">' +
        //     swatchItems.join(' ') +
        //     '</div>';
        // }

        html = '<div class="color-swatches">' + swatchItems + '</div>';

        return html;
    }

    function bgset(image) {
        var bgset = '';
        if (image) {
            var aspect_ratio = image.width / image.height;

            if (image.width > 180) bgset += ' ' + Utils.optimizeImage(image.src, '180x') + ' 180w ' + Math.round(180 / aspect_ratio) + 'h,';
            if (image.width > 360) bgset += ' ' + Utils.optimizeImage(image.src, '360x') + ' 360w ' + Math.round(360 / aspect_ratio) + 'h,';
            if (image.width > 540) bgset += ' ' + Utils.optimizeImage(image.src, '540x') + ' 540w ' + Math.round(540 / aspect_ratio) + 'h,';
            if (image.width > 720) bgset += ' ' + Utils.optimizeImage(image.src, '720x') + ' 720w ' + Math.round(720 / aspect_ratio) + 'h,';
            if (image.width > 900) bgset += ' ' + Utils.optimizeImage(image.src, '900x') + ' 900w ' + Math.round(900 / aspect_ratio) + 'h,';
            if (image.width > 1080) bgset += ' ' + Utils.optimizeImage(image.src, '1080x') + ' 1080w ' + Math.round(1080 / aspect_ratio) + 'h,';
            if (image.width > 1296) bgset += ' ' + Utils.optimizeImage(image.src, '1296x') + ' 1296w ' + Math.round(1296 / aspect_ratio) + 'h,';
            if (image.width > 1512) bgset += ' ' + Utils.optimizeImage(image.src, '1512x') + ' 1512w ' + Math.round(1512 / aspect_ratio) + 'h,';
            if (image.width > 1728) bgset += ' ' + Utils.optimizeImage(image.src, '1728x') + ' 1728w ' + Math.round(1728 / aspect_ratio) + 'h,';
            if (image.width > 1950) bgset += ' ' + Utils.optimizeImage(image.src, '1950x') + ' 1950w ' + Math.round(1950 / aspect_ratio) + 'h,';
            if (image.width > 2100) bgset += ' ' + Utils.optimizeImage(image.src, '2100x') + ' 2100w ' + Math.round(2100 / aspect_ratio) + 'h,';
            if (image.width > 2260) bgset += ' ' + Utils.optimizeImage(image.src, '2260x') + ' 2260w ' + Math.round(2260 / aspect_ratio) + 'h,';
            if (image.width > 2450) bgset += ' ' + Utils.optimizeImage(image.src, '2450x') + ' 2450w ' + Math.round(2450 / aspect_ratio) + 'h,';
            if (image.width > 2700) bgset += ' ' + Utils.optimizeImage(image.src, '2700x') + ' 2700w ' + Math.round(2700 / aspect_ratio) + 'h,';
            if (image.width > 3000) bgset += ' ' + Utils.optimizeImage(image.src, '3000x') + ' 3000w ' + Math.round(3000 / aspect_ratio) + 'h,';
            if (image.width > 3350) bgset += ' ' + Utils.optimizeImage(image.src, '3350x') + ' 3350w ' + Math.round(3350 / aspect_ratio) + 'h,';
            if (image.width > 3750) bgset += ' ' + Utils.optimizeImage(image.src, '3750x') + ' 3750w ' + Math.round(3750 / aspect_ratio) + 'h,';
            if (image.width > 4100) bgset += ' ' + Utils.optimizeImage(image.src, '4100x') + ' 180w ' + Math.round(4100 / aspect_ratio) + 'h,';
            bgset += ' ' + image.src + ' ' + image.width + 'w ' + image.height + 'h,';
        }
        return bgset;
    }

    // Build Pagination
    ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
        if (!totalProduct) totalProduct = this.totalProduct

        // Get page info
        var currentPage = parseInt(Globals.queryParams.page);
        var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

        if (totalPage > 1) {
            var paginationHtml = boostPFSTemplate.paginateHtml;
            // Build Previous
            var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
            // Build Next
            var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
            // Create page items array
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
                beforeCurrentPageArr.unshift('...');
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            beforeCurrentPageArr.push(currentPage);
            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push('...');
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }
            // Build page items
            var pageItemsHtml = '';
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == '...') {
                    pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
            return paginationHtml;
        }

        return '';
    };

    // Build Sorting
    ProductSorting.prototype.compileTemplate = function () {
        if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
            var sortingArr = Utils.getSortingList();
            if (sortingArr) {
                // Build content
                var sortingItemsHtml = '';
                for (var k in sortingArr) {
                    sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
                }
                var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
                return html;
            }
        }
        return '';
    };

    // Add additional feature for product list, used commonly in customizing product list
    ProductList.prototype.afterRender = function (data, eventType) {
        if (!data) data = this.data
        if (!eventType) eventType = this.eventType

        if (boostPFSConfig.custom.enable_quickshop && data.length > 0) {
            var count = 0;
            data.forEach(function (product) {
                var url = Utils.buildProductItemUrl(product, true);
                jQ.ajax({
                    type: "GET",
                    url: url + '?view=boost-pfs-quickview',
                    success: function (result) {
                        if (jQ('[data-boost-pfs-quickshop-id="' + product.id + '"]').length == 1) {
                            jQ('[data-boost-pfs-quickshop-id="' + product.id + '"]').replaceWith(result);
                        }
                        count++;
                        if (count == data.length) {
                            buildTheme();
                        }
                    }
                });
            })
        } else {
            buildTheme();
        }
    };

    // Build additional elements
    Filter.prototype.afterRender = function (data, eventType) {
    };

    FilterResult.prototype.afterRender = function () {

        var data = this.data;  // products and other info

       
 // Product size
            var hsize = false
            var wsize = false
    
            var size_tag = '';

        // Collection based color swatches

        var color_swatch = '';

        var collection_name = "";

        // console.log(data);

        data.products.forEach((product) => {
             // console.log(product);

           
          
            var collectionSwatchItems = [];
            var collectionPages = [];

         color_swatch = '';

         collection_name = "";

             size_tag = '';
                hsize = false;
                wsize = false;


            product.tags.forEach((tag) => {
              
                if (tag.indexOf("height:") != -1) {
                    hsize = tag.match(/\d+/g).map(Number)[0];
                }

                if (tag.indexOf("width:") != -1) {
                    wsize = tag.match(/\d+/g).map(Number)[0];
                }

                if (tag.indexOf("collection_name:") != -1) {
                    collection_name = tag.match(/\d+/g).map(Number);

                   // console.log(collection_name);
                   
                  
(window.__vchSw=window.__vchSw||{},window.__vchSw[collection_name]=window.__vchSw[collection_name]||
    
    $.getJSON("/collections/"+collection_name+"/products.json?limit=9&fields=id,images,collections,tags")).done(function(response){

                        // console.log('product lenght:' + response.products.length);
                        if (response.products.length > 0) {
                          
                            var count = response.products.length;
  
                            var counter = 0;
                     
                            $.each(response.products, function (i, item) {
                              var not_public = false;
                            
                              item.tags.forEach((tag) => {
                                if (tag.indexOf("not_public") != -1) {
                                   not_public = true;
                                }
                              });

                                if (item.images.length && !not_public) {

                                    if (item.id != product.id) {
                                        
                                         counter++;
                                  
                                        // if(counter == 8){
                                        //   color_swatch = '<div class="swatch">+</div>'
                                        // } else if(counter >= 9){
                                        //   color_swatch = '';
                                        // } else {
                                          color_swatch = '<div class="swatch"><a href="/products/' + item.handle + '"><img src="'+item.images[0].src+(item.images[0].src.indexOf('?')>-1?'&':'?')+'width=120" loading="lazy" alt="' + item.handle + '"></a></div>'
                                        //}
                                    
                                        collectionSwatchItems.push(color_swatch);
                                    }
                                }

                                if (!--count) {
                                  console.log($('div.boost-pfs-filter-products').find('> div[data-swatch-id="' + product.id + '"] .color-swatches').length);
                                  if($('div.boost-pfs-filter-products').find('> div[data-swatch-id="' + product.id + '"] .color-swatches').length == 0) {
                                    $('div.boost-pfs-filter-products').find('> div[data-id="' + product.id + '"] .color-swatches').html(collectionSwatchItems);
                                  } else {
                                    $('div.boost-pfs-filter-products').find('> div[data-swatch-id="' + product.id + '"] .color-swatches').html(collectionSwatchItems);
                                  }
                                }
                            });
                          if(counter > 8){
                              if($('div.boost-pfs-filter-products').find('> div[data-swatch-id="' + product.id + '"] .color-swatches').length == 0) {
                                $('div.boost-pfs-filter-products').find('> div[data-id="' + product.id + '"] .color-swatches').append('<div class="swatch opener"></div>');
                                $('div.boost-pfs-filter-products').find('> div[data-id="' + product.id + '"] .color-swatches .swatch.opener').on('click', function(){
                                  $('div.boost-pfs-filter-products').find('> div[data-id="' + product.id + '"] .color-swatches .swatch').show();
                                  $('div.boost-pfs-filter-products').find('> div[data-id="' + product.id + '"] .color-swatches .swatch.opener').hide();
                                });
                              } else {
                                $('div.boost-pfs-filter-products').find('> div[data-swatch-id="' + product.id + '"] .color-swatches').append('<div class="swatch opener"></div>');
                                $('div.boost-pfs-filter-products').find('> div[data-swatch-id="' + product.id + '"] .color-swatches .swatch.opener').on('click', function(){
                                  $('div.boost-pfs-filter-products').find('> div[data-swatch-id="' + product.id + '"] .color-swatches .swatch').show();
                                  $('div.boost-pfs-filter-products').find('> div[data-swatch-id="' + product.id + '"] .color-swatches .swatch.opener').hide();
                                });
                              }
                          }

                        }

                    });


                }
            });

            var availability = '';
        });

      $('[data-add-to-cart]').on('click', function(){
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              items: [{
                id: $(this).data('id'),
                quantity: 1,
                properties: {}
              }]
            },
            dataType: 'json',
            success: function(data) {
              window.PXUTheme.jsAjaxCart.updateView();
              $('.header-cart.action-area__link').addClass('show-mini-cart');
            },  
            error: function(data, textstatus) {
              //  console.log(data);
              // alert(data.responseJSON.message + '. ' + data.responseJSON.description);
              // alert("Something went wrong. Please try again. Contact us if it doesn't help.");
            },
          });
      })

      
               

    }

    function buildTheme() {
        if (window.SPR && typeof SPR.initDomEls == 'function' && typeof SPR.loadBadges == 'function') {
            SPR.initDomEls();
            SPR.loadBadges();
        }

        if (typeof Shopify.PaymentButton != 'undefined' && typeof Shopify.PaymentButton.init == 'function') {
            Shopify.PaymentButton.init();
        }

        if (boostPFSConfig.custom.hasOwnProperty('show_multiple_currencies') &&
            boostPFSConfig.custom.show_multiple_currencies == true &&
            typeof convertCurrencies == 'function') {
            convertCurrencies();
        }

    }
})();